import { Col } from 'antd';




import logo2 from 'assets/newlogo.svg';
import { LoginForm } from 'features/auth/components';
import { StyledBackground, StyledCard, StyledRow } from './login.styles';

export const LoginView = () => {

  return (
    <StyledBackground align='middle' justify='center' className='sctn_login'>
      <Col xs={24} sm={18} md={12} lg={8}>
        <div className='lgn_logo'>
          <img src={logo2} alt="" />
          <p style={{ color: "#3F3F3F", fontSize:"30px", width:"500"}}>Client Portal</p>
        </div>
        <StyledCard className='sl_bx'>
          <StyledRow className='slb_rw'>
            <Col xs={24} className='slbr_clm'>
              <LoginForm />
            </Col>
          </StyledRow>
        </StyledCard>
      </Col>
    </StyledBackground>
  );
};
